import { FETCH_PSEUDO_GROUP_SECURITY_GROUPS } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_PSEUDO_GROUP_SECURITY_GROUPS:
			return action.payload;
		default:
			return state;
	}
};
